import React from "react";

import Box from "themeComponents/Box";
import Typography from "themeComponents/Typography";

interface CourseMetaItemProps {
  icon: React.ReactNode;
  text: React.ReactNode;
  truncate?: boolean;
}

function CourseMetaItem({ icon, text, truncate = false }: CourseMetaItemProps): React.JSX.Element {
  return (
    <Box display="flex" alignItems="center" gap={1} {...({} as any)}>
      {icon}
      <Typography
        variant="caption"
        color="text"
        sx={
          truncate
            ? { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }
            : undefined
        }
      >
        {text}
      </Typography>
    </Box>
  );
}

export default CourseMetaItem;